import * as React from 'react'
import { Form, Input, InputNumber, Modal } from 'antd'
import { FormInstance } from 'antd/lib/form'

import { TTModalProps } from '../shared/TTModalProps'
import { TTInputCurrency } from '../shared/TTInputCurrency'
import { StressTestRettificaModel, StressTestRow } from '../../models/StressTestModels'
import { IStresstestService } from '../../services/StresstestService'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'
import { TTSelect } from '../shared/TTSelect'
import { KeyValueModel } from '../../models/ModelBase'
import { renderSelectKeyValue } from '../../services/shared/SelectOptionRenderUtils'
import { renderSelectList } from '../shared/SelectOptionRenderUtils'
import TextArea from 'antd/lib/input/TextArea'
import { TTFormItem } from '../shared/TTFormItem'

interface ModalRettificaProps extends TTModalProps {
    //data?: StressTestRettificaModel,
    StressTestId: string
    stressTestDetailId: string
    rettificalId?: string
    monthIndex: number
}

class ModalRettificaState extends StressTestRettificaModel {
    VariazioneList: Array<KeyValueModel>
    NrMonthVisible: boolean = false
}

//class ModalAmountState {
//    amount: number
//    variazioneEuro: number
//    variazionePerc: number
//}

export class ModalRettifica extends React.Component<ModalRettificaProps, ModalRettificaState> {

    formRef = React.createRef<FormInstance>()
    inputRef = React.createRef<HTMLInputElement>()

    variazioneEuro: number
    variazionePerc: number
    variazioneType: string
    nota: string
    nrMesi: number = 12
    meseIniziale: number 
    service: IStresstestService


    constructor(props) {
        super(props)
        this.service = container.get(SERVICE_IDENTIFIER.STRESSTEST_SERVICE)
        let _state = new ModalRettificaState()
        let a: KeyValueModel = { Key: "SingoloMese", Value: "Singolo mese" }
        let b: KeyValueModel = { Key: "MultiMese", Value: "Multi mese" }
        _state.VariazioneList = [a, b]
        this.state = _state

    }

    componentDidMount() {
        if (this.props.rettificalId == null) return
        this.loadPage()
    }

    loadPage = async () => {
        let resp = await this.service.GetRettifica(this.props.rettificalId)
        if (resp.IsValid == true) {
            this.formRef.current.setFieldsValue({
                VariazioneType: resp.VariazioneType == "0" ? "SingoloMese" : "MultiMese",
                Nota: resp.Nota,
                StressTestDetailId: resp.StressTestDetailId,
                VariazionePerc: resp.VariazionePerc,
                VariazioneEuro: resp.VariazioneValuta,
                NrMesi: resp.NrMesi,
            })
            this.meseIniziale = resp.MeseIniziale
            let modal = this.state
            this.setState({ ...modal, NrMonthVisible: resp.VariazioneType != "0" })
        }
    }

    //componentDidUpdate(prevProps: ModalRettificaProps) {
    //    if (prevProps.visible == false && this.props.visible == true) {
    //        this.inputRef.current.focus()
    //        //this.updateAmount(this.props.value)
    //    }

    //}

    //closeModal = () => {
    //    this.formRef.current.resetFields()
    //    this.props.closeModal()
    //}

    onSave = async () => {
        try {
            let data = await this.formRef.current.validateFields()
            let model = new StressTestRettificaModel()
            if (this.props.rettificalId != null)
                model.Id = this.props.rettificalId
            model.StressTestDetailId = this.props.stressTestDetailId
            model.MeseIniziale = this.props.rettificalId == null ? this.props.monthIndex + 1 : this.meseIniziale
            model.VariazionePerc = data["VariazionePerc"]
            model.VariazioneValuta = data["VariazioneEuro"]
            model.NrMesi = data["NrMesi"]
            model.VariazioneType = data["VariazioneType"]
            model.Nota = data["Nota"]
            model.StressTestId = this.props.StressTestId
            await this.service.SaveRettifica(model)
            this.props.do(true)
        } catch (err) {
            this.closeModal()
            console.log(err)
        }
    }

    closeModal = () => {
        this.formRef.current.resetFields()
        this.props.closeModal()
    }

    render() {
        return (
            <Modal
                title="Inserisci l'incremento o il decremento"
                visible={this.props.visible}
                onCancel={this.closeModal}
                onOk={this.onSave}>
                <Form ref={this.formRef}>
                    <TTFormItem
                        label="Modalità variazione"
                        name="VariazioneType"
                        initialValue={(this.variazioneType == null ? "SingoloMese" : this.variazioneType)}
                    >
                        <TTSelect size="small" onChange={(e) => { let model = this.state; this.setState({ ...model, NrMonthVisible: e == "MultiMese" }) }} >
                            {renderSelectKeyValue(this.state.VariazioneList)}
                        </TTSelect>
                    </TTFormItem>
                    {this.state.NrMonthVisible ?
                        <TTFormItem
                            label="Nr Mesi"
                            name="NrMesi"
                            initialValue={this.nrMesi}
                        >
                            <InputNumber />
                        </TTFormItem> : <></>
                    }

                    <TTFormItem
                        label="Variazione (€)"
                        name="VariazioneEuro"
                        initialValue={this.variazioneEuro}
                    >
                        <TTInputCurrency ref={this.inputRef} />
                    </TTFormItem>
                    <TTFormItem
                        label="Variazione (%)"
                        name="VariazionePerc"
                        initialValue={(this.variazionePerc == null ? 0 : this.variazionePerc)}
                    >
                        <InputNumber />
                    </TTFormItem>
                    <TTFormItem
                        label="Note"
                        name="Nota" required={true }
                        initialValue={this.nota}
                    >
                        <TextArea />
                    </TTFormItem>
                </Form>
            </Modal>
        )
    }
}